<!-- @format -->

<template>
	<commom-vue
		:id="id"
		class="applicationSystem"
		:is-workbenchedit="isWorkbenchedit"
		title="应用系统"
		@handle-click-title="handleClick"
	>
		<div class="applicationSystem-top">
			<div class="img"></div>
			<div class="vertical-center">
				<div>
					<div>
						应用系统数
						<el-tooltip v-if="false" content="(当天)" placement="top">
							<el-icon style="vertical-align: middle"><QuestionFilled /></el-icon>
						</el-tooltip>
					</div>
					<div>
						<span class="num">{{ isNumber(numData?.resTotal) ? parseInt(numData.resTotal) : '-' }}</span
						>&nbsp;个
					</div>
				</div>
			</div>
			<el-row class="right">
				<el-col :span="7" class="vertical-center">
					<svg-icon name="jkyys" class="icon" />
					<div>
						<div class="title" style="color: #078f59">
							{{
								isNumber(numData?.appVisits)
									? numData.appVisits > 10000
										? parseFloat((numData.appVisits / 10000).toFixed(2))
										: numData.appVisits
									: '-'
							}}<span class="unit"
								>&nbsp;{{ isNumber(numData?.appVisits) && numData.appVisits > 10000 ? '万次' : '次' }}</span
							>
						</div>
						<div class="name">
							应用请求数
							<el-tooltip v-if="false" placement="top" content="所有应用系统的今日请求数之和" raw-content>
								<span class="tip">
									<el-icon><QuestionFilled /></el-icon>
								</span>
							</el-tooltip>
						</div>
					</div>
				</el-col>
				<el-col :span="1" class="vertical-center">
					<div class="line"></div>
				</el-col>
				<el-col :span="7" class="vertical-center">
					<svg-icon name="fwcg" class="icon" />
					<div>
						<div class="title">
							{{ isNumber(numData?.visitSuccessRate) ? numData.visitSuccessRate : '-'
							}}<span class="unit">&nbsp;%</span>
						</div>
						<div class="name"
							>请求成功率
							<el-tooltip
								v-if="false"
								placement="top"
								content="所有应用系统今日所有请求的成功率，请求状态包括：成功、缓慢、超时"
								raw-content
							>
								<span class="tip">
									<el-icon><QuestionFilled /></el-icon>
								</span>
							</el-tooltip>
						</div>
					</div>
				</el-col>
				<el-col :span="1" class="vertical-center">
					<div class="line"></div>
				</el-col>
				<el-col :span="7" class="vertical-center">
					<svg-icon name="xysc" class="icon" />
					<div>
						<div class="title">
							{{ isNumber(numData?.avgRT) ? numData.avgRT : '-' }}<span class="unit">&nbsp;毫秒</span>
						</div>
						<div class="name"
							>平均响应时长
							<el-tooltip v-if="false" placement="top" content="所有应用系统今日所有请求的平均响应时长" raw-content>
								<span class="tip">
									<el-icon><QuestionFilled /></el-icon>
								</span>
							</el-tooltip>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="applicationSystem-center">
			<div class="left">
				健康视图:<span class="jk">健康度(0-100分)</span>
				<el-tooltip placement="top" raw-content>
					<template #content>
						<div>应用响应时间 T = 500 ms</div>
						<div>Satisfied（满意）：应用响应时间低于或等于 T</div>
						<div>Tolerating（可容忍）：应用响应时间大于 T，但同时小于或等于 4T</div>
						<div>Frustrated（烦躁期）：应用响应时间大于 4T</div>
						<div>应用健康度 = [ 满意数量 +（ 可容忍数量 / 2 ）] / 总样本数 * 100</div>
					</template>
					<span class="gs">
						<el-icon><QuestionFilled /></el-icon>
					</span>
				</el-tooltip>
			</div>
			<div class="right">
				<span class="level-num-box" @click="handleClickLenged('green')">
					<i :style="{ background: lenged.green ? '#078F59' : '#ccc' }" />满意(75-100)
				</span>
				<span class="level-num-box" @click="handleClickLenged('blue')">
					<i :style="{ background: lenged.blue ? '#1D59F2' : '#ccc' }" />合格(30-75)
				</span>
				<span class="level-num-box" @click="handleClickLenged('red')">
					<i :style="{ background: lenged.red ? '#E02C1F' : '#ccc' }" />不合格(0-30)
				</span>
			</div>
		</div>
		<div class="applicationSystem-bottom">
			<div class="bottom-box">
				<template v-for="(item, index) in widgetData" :key="item">
					<template v-if="index < 13">
						<div
							class="vertical"
							:style="{
								top: position[index].top,
								left: position[index].left,
							}"
						>
							<template v-if="item.apdex && item.apdex >= 75">
								<template v-if="lenged.green">
									<div> {{ item.sysName }}({{ isNumber(item.apdex) ? item.apdex + '分' : '-' }}) </div>
									<div class="icon-div">
										<svg-icon name="app-g" class="icon" style="cursor: pointer" @click="handleClickSon(item)" />
									</div>
								</template>
							</template>
							<template v-else-if="item.apdex && item.apdex >= 35">
								<template v-if="lenged.blue">
									<div> {{ item.sysName }}({{ isNumber(item.apdex) ? item.apdex + '分' : '-' }}) </div>
									<div class="icon-div">
										<svg-icon name="app-b" class="icon" style="cursor: pointer" @click="handleClickSon(item)" />
									</div>
								</template>
							</template>
							<template v-else>
								<template v-if="lenged.red">
									<div> {{ item.sysName }}({{ isNumber(item.apdex) ? item.apdex + '分' : '-' }}) </div>
									<div class="icon-div">
										<svg-icon name="app-r" class="icon" style="cursor: pointer" @click="handleClickSon(item)" />
									</div>
								</template>
							</template>
						</div>
					</template>
				</template>
			</div>
		</div>
	</commom-vue>
</template>

<script lang="ts" setup>
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { openWindow } from '@power/utils';
	import commomVue from './common.vue';
	import { position } from './applicationSystem';
	import { getWidgetData, subsysList, getMenu } from '@/api/workbenchAll';
	import { isNumber } from '@/utils';

	defineProps({
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
	});
	const numData = ref<any>({
		appVisits: '',
		visitSuccessRate: '',
		avgRT: '',
		healthApps: '',
		resTotal: '',
	});
	const lenged = ref({
		green: true,
		blue: true,
		red: true,
	});
	const handleClickLenged = (key) => {
		lenged.value[key] = !lenged.value[key];
	};
	const widgetData = ref<any>([]);
	const getData = async () => {
		widgetData.value = [];
		const res = await getWidgetData('applicationSystem', { flag: true });
		numData.value = res;
		const widget = (res && res.appList) || [];
		let menus = [];
		const subsys: any = await subsysList({});
		const sysId = subsys.data.find((item) => item.alias === 'powersystem').id;
		if (sysId) {
			const res2: any = await getMenu({ systemId: sysId });
			menus = res2.data.filter(
				(item) =>
					item.resourceType === 'menu' && item.displayInMenu === 'Y' && item.defaultUrl !== window.location.pathname,
			);
		}
		widget.forEach((item: any) => {
			menus.forEach((item2: any) => {
				if (item.sysId === item2.alias) {
					widgetData.value.push(item);
				}
			});
		});
		// widgetData.value
	};
	const handleClick = () => {
		// const url =
		// 	getEnvUrlByUrl(`powersystem/inner/`) +
		// 	encodeURIComponent(getEnvUrlByUrl('/powerportal/businessSys?plmhm=0&pcbcTitle=应用总览'));
		const url = getEnvUrlByUrl('/powerapmnew/overview');
		window.location.href = url;
	};
	const handleClickSon = (data) => {
		const url = getEnvUrlByUrl(
			`/powerportal/businessSysSon/${encodeURIComponent(data.sysId)}?plmhm=0&pcbcTitle=${encodeURIComponent(
				data.sysName,
			)}`,
		);
		// const url = getEnvUrlByUrl(`/powerapmnew/app-analyze/detail/${encodeURIComponent(data.sysId)}?searchTime=${encodeURIComponent(dayjs().format('YYYY-MM-DD 0000'))}&searchTime=${encodeURIComponent(dayjs().format('YYYY-MM-DD HHmm'))}&sysNm=${encodeURIComponent(data.sysNm)}`);
		openWindow(url);
	};
	getData();
</script>

<style lang="scss" scoped>
	.applicationSystem {
		.applicationSystem-top {
			height: 20%;
			margin-top: 2%;
			position: relative;

			.tip {
				font-size: 1.2rem;
				color: #3369f4;
				vertical-align: bottom;
			}

			.img {
				// background: url('@/assets/images/application.png') no-repeat;
				background-size: 100% 100%;
				width: 10%;
				height: 100%;
				float: left;
			}

			.vertical-center {
				width: 90%;
				float: right;
				display: flex;
				align-items: center;
				height: 100%;
				font-size: 1.4rem;
				color: #3e4760;
				padding-left: 2%;

				.num {
					font-weight: 500;
					font-size: 3rem;
					color: rgba(0, 0, 0, 0.9);
				}
			}

			.right {
				width: 70%;
				position: absolute;
				right: 0;
				background: #f4f6fd;
				height: 100%;

				.vertical-center {
					background: #f4f6fd;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100%;

					.line {
						width: 1px;
						background: rgba(29, 89, 242, 0.2);
						height: 50%;
					}

					.icon {
						width: 25%;
						height: 57%;
						margin-right: 8%;
					}

					.icon-jk {
						// background: url('@/assets/images/jkyys.png') no-repeat;
						background-size: 100% 100%;
					}

					.icon-fw {
						// background: url('@/assets/images/fwcg.png') no-repeat;
						background-size: 100% 100%;
					}

					.icon-xy {
						// background: url('@/assets/images/xysc.png') no-repeat;
						background-size: 100% 100%;
					}

					.title {
						font-weight: bold;
						font-size: 2.2rem;
						color: var(--theme-color-primary);
						text-align: center;

						.unit {
							font-size: 1.8rem;
							font-weight: normal;
						}
					}

					.name {
						font-size: 1.4rem;
						color: #3e4760;
						text-align: center;
					}
				}
			}
		}

		.applicationSystem-center {
			height: 15%;

			.left,
			.right {
				float: left;
				width: 50%;
				font-size: 1.6rem;
				color: rgba(0, 0, 0, 0.8);
				display: flex;
				align-items: center;
				height: 100%;
			}

			.left {
				display: flex;
				align-items: center;

				.jk {
					font-size: 1.4rem;
					color: rgba(0, 0, 0, 0.6);
					margin-top: 2px;
				}

				.gs {
					font-size: 1.2rem;
					color: #3369f4;

					i {
						vertical-align: middle;
					}
				}
			}

			.right {
				font-size: 1.4rem;
				justify-content: flex-end;

				.level-num-box {
					margin-left: 5%;
					cursor: pointer;

					i {
						content: '';
						width: 10px;
						height: 10px;
						display: inline-block;
						margin-right: 5px;
					}
				}
			}
		}

		.applicationSystem-bottom {
			height: calc(100% - 40%);
			padding: 10px 30px;

			.bottom-box {
				// background-image: url('@/assets/images/applicationSystem-bg.png');
				background-position: center center;
				background-repeat: no-repeat;
				background-size: contain;
				position: relative;
				height: 100%;
			}

			.vertical {
				font-size: 1.4rem;
				color: #000000;
				font-weight: 500;
				position: absolute;
				transform: translate(-50%, -50%);
				line-height: 3.2rem;
				white-space: nowrap;

				.icon-div {
					text-align: center;
				}

				.icon {
					width: 35px;
					height: 35px;
					display: inline-block;
				}

				.icon-r {
					// background: url('@/assets/images/app-r.png') no-repeat;
					background-size: 100% 100%;
				}

				.icon-g {
					// background: url('@/assets/images/app-g.png') no-repeat;
					background-size: 100% 100%;
				}

				.icon-b {
					// background: url('@/assets/images/app-b.png') no-repeat;
					background-size: 100% 100%;
				}
			}
		}
	}
</style>
